import script from "./PayQrCodeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PayQrCodeDialog.vue?vue&type=script&setup=true&lang=js"

import "./PayQrCodeDialog.vue?vue&type=style&index=0&id=bdb036d4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdb036d4"]])

export default __exports__